/* eslint-disable no-await-in-loop */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-useless-return */
/* eslint-disable no-inner-declarations */
/* eslint-disable no-unsafe-optional-chaining */
import React, { memo, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Col, Form, message, Modal, Row, Spin } from 'antd';
import { Scheduler } from 'devextreme-react';
import { AppointmentDragging, Resource } from 'devextreme-react/scheduler';
import moment from 'moment';
import { useLocation, useParams } from 'react-router-dom';

import { LoadingOutlined } from '@ant-design/icons';

import Utils from '../../Assets/Scripts/Utils';
import QuoteList from '../../Components/QuoteList/QuoteList';
import ReasonModal from '../../Components/ReasonModal/ReasonModal';
import { readPortalResource } from '../../Components/ResourceFieldLayout/shouldRenderTaskField';
import Appointment, {
  stripNativeTitleFromSchedulerAppointment,
} from '../../Components/Schedule/Appointment';
import AppointmentTooltipComponent from '../../Components/Schedule/AppointmentTooltip';
import DataCell from '../../Components/Schedule/DataCell';
import DateCell from '../../Components/Schedule/DateCell';
import InstructorBookingPopup from '../../Components/Schedule/InstructorBooking/InstructorBookingPopup';
import ModalConfirmBody from '../../Components/Schedule/ModalConfirmBody';
import NewSlotPopup from '../../Components/Schedule/NewSlotPopup';
import OverviewPopup from '../../Components/Schedule/OverviewPopup';
import ResourceCellRender from '../../Components/Schedule/ResourceCellRender';
import ResumePopup from '../../Components/Schedule/ResumePopup';
import ScheduleUtils from '../../Components/Schedule/ScheduleUtils';
import TaskCommentFunctions from '../../Components/Schedule/TaskCommentFunctions';
import { api } from '../../Services/axiosService';
import { loadAgendaFieldLayout } from '../Role/FieldCustomization/API/FieldCustomizationApi';
import UserFunctions from '../User/Register/UserFunctions';

import {
  fetchProduct,
  fetchSchedulingScheduleFilter,
  fetchTasks,
} from './API/ScheduleSchedulingAPI';
import SchedulingFunctions from './API/SchedulingFunctions';
import TaskDrawer from './Components/TaskDrawer';

import './ScheduleScheduling.scss';

let scheduleDate = moment(new Date()).format('YYYY-MM-DD');
let currentCTName = '';
let taskAcceptanceDeadline = 0;

let currentOpenTask = null;
let event = '';
let onModalOk = null;
let firstOpen = true;

// 39 = Logística
const hideListIds = [39];

const views = [
  {
    name: 'Dia',
    type: 'day',
    cellDuration: 60,
  },
];

const notifyDisabledDate = () => {
  message.warning('Não é possível criar ou mover um treinamento para uma data desabilitada.');
};

const notifyDisableDelete = () => {
  message.warning('Não é possível remover um agendamento neste estágio!');
};

const notifyRetroactiveDay = () => {
  message.warning('Não é possível agendar treinamentos em dias retroativos!');
};

const notifyExceededCapacity = (students, capacity) => {
  message.warning(`Capacidade de alunos por dia excedida (${students}/${capacity})!`);
};

function pickAgendaColumnsForCenter(searchedCenter, centerSlots, rangeStart, rangeEnd) {
  if (!searchedCenter) {
    return [];
  }

  const resourcesByDate = {};
  SchedulingFunctions.calculateResourceSlots(
    resourcesByDate,
    searchedCenter,
    centerSlots,
    rangeStart,
    rangeEnd
  );

  const firstDateKey = Object.keys(resourcesByDate)[0];
  return resourcesByDate[firstDateKey] ?? [];
}

function resolveAgendaTaskForGrid(task, columns) {
  const storedType = task.resource || task.trainingType;
  const placement = SchedulingFunctions.resolveAgendaResourceId(
    task.resourceId,
    storedType,
    columns
  );

  if (placement.kind === 'no-destination') {
    return null;
  }

  if (placement.kind === 'remapped') {
    return { ...task, resourceId: placement.resourceId };
  }

  return task;
}

function resolveAgendaTasksForGrid(fetchedTasks, columns) {
  if (!fetchedTasks?.length) {
    return [];
  }

  return fetchedTasks
    .map((task) => resolveAgendaTaskForGrid(task, columns))
    .filter((placedTask) => placedTask != null);
}

function ScheduleSchedulingComponent() {
  // eslint-disable-next-line radix
  const dealId = window.location.search.split('=')[1];
  const draggingGroupName = 'appointmentsGroup';
  const groups = ['resourceId'];

  const schedulerRef = useRef(null);
  const newSlotPopupRef = useRef(null);
  const overviewPopupRef = useRef(null);
  const resumePopupRef = useRef(null);
  const instructorBookingPopupRef = useRef(null);
  const quoteListRef = useRef();

  const urlParams = useParams();
  const location = useLocation();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [loadingSchedule, setLoadingSchedule] = useState(false);
  const [scheduleParams, setScheduleParams] = useState();
  const [appointments, setAppointments] = useState([]);
  const [trainingCenter, setTrainingCenter] = useState();
  const [quoteList, setQuoteList] = useState([]);
  const [instructorOptions, setInstructorOptions] = useState();
  const [driverOptions, setDriverOptions] = useState();
  const [transportOptions, setTransportOptions] = useState([]);
  const [invoiceIssuersOptions, setInvoiceIssuersOptions] = useState([]);
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [trainingsOptions, setTrainingsOptions] = useState();
  const [blockedDates, setBlockedDates] = useState([]);
  const [instructorsBlockedDates, setInstructorsBlockedDates] = useState([]);
  const [slots, setSlots] = useState([]);
  const [fieldsPermissions, setFieldsPermissions] = useState();
  const [agendaResourceId, setAgendaResourceId] = useState();
  const [agendaResourceName, setAgendaResourceName] = useState();
  const [fieldLayout, setFieldLayout] = useState();
  const [stages, setStages] = useState();
  const [ctResources, setCtResources] = useState();
  const [ctResourcesSlots, setCtResourcesSlots] = useState();
  const [isReasonModalOpen, setReasonModalOpen] = useState(false);
  const [reasonsOptions, setReasonsOptions] = useState();
  const [usedCapacity, setUsedCapacity] = useState(0);
  const [bitrixProducts, setBitrixProducts] = useState([]);
  const [overview, setOverview] = useState([]);
  const [resume, setResume] = useState([]);
  const [bitrixUsers, setBitrixUsers] = useState([]);
  const [openTraining, setOpenTraining] = useState();
  const [reasonNoBillingOptions, setReasonNoBillingOptions] = useState([]);
  const [trainingCenterOptions, setTrainingCenterOptions] = useState();
  const [taskRescheduling, setTaskRescheduling] = useState(null);
  const [isTaskReadOnly, setIsTaskReadOnly] = useState(false);
  const [roleId, setRoleId] = useState();
  const [settings, setSettings] = useState();

  const sortAppointmentsByPriority = (appointmentList = []) =>
    ScheduleUtils.sortAppointmentsBySlotEnqueueOrder(appointmentList);

  const setSortedAppointments = (updater) => {
    setAppointments((prevAppointments) => {
      const nextAppointments =
        typeof updater === 'function' ? updater(prevAppointments) : updater ?? [];
      return sortAppointmentsByPriority(nextAppointments);
    });
  };

  // Certificado
  const [certificateModelOptions, setCertificateModelOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [isTaskDrawerVisible, setIsTaskDrawerVisible] = useState(false);
  const [currentTaskId, setCurrentTaskId] = useState(null);

  // Filtros
  const [schedulingScheduleFilter, setSchedulingScheduleFilter] = useState();

  const isLogistic = hideListIds.some((id) => id === roleId);

  let schedulerDefaultDate = null;
  if (schedulingScheduleFilter?.filters?.currentDate) {
    const [year, month, day] = schedulingScheduleFilter.filters.currentDate.split('-');
    schedulerDefaultDate = new Date(Number(year), Number(month) - 1, Number(day));
  }

  const getCurrentDate = () => scheduleDate;

  const updateOverviewAndResume = () => {
    const currentStartDate = schedulerRef.current.instance.getStartViewDate();
    const currentEndDate = schedulerRef.current.instance.getStartViewDate();
    const startDate = moment(currentStartDate.setHours(0, 0, 0, 1)).format('YYYY-MM-DDTHH:mm:ss');
    const endDate = moment(currentEndDate.setHours(23, 59, 59, 999)).format('YYYY-MM-DDTHH:mm:ss');
    SchedulingFunctions.getOverviewData(appointments, setOverview, startDate, endDate);
    SchedulingFunctions.getResumeData(appointments, setResume, startDate, endDate);
  };

  const schedulingType = async (e, oldTaskData, startDate) => {
    try {
      const dataToSave = { ...e };
      const scheduleData = JSON.parse(localStorage.getItem('conecta__scheduleData'));

      if (dataToSave.acceptTerm2 && dataToSave.acceptTerm2 !== '') {
        dataToSave.stage = stages.find(({ id }) => id === 12); // 12 = Estágio "Reservado"
      } else {
        dataToSave.stage = stages.find(({ id }) => id === 10); // 10 = Estágio "Pré-Reservado"
      }

      dataToSave.trainingCenter = trainingCenter?.commercialName ?? scheduleData.trainingCenter;
      dataToSave.trainingCenterId = trainingCenter?.id ?? scheduleData.trainingCenterId;

      setLoadingSchedule(true);

      const { data: savedTask } = await api.put(
        '/Task/UpdateTaskScheduling?btnAction=Agendar',
        dataToSave
      );

      dataToSave.stage = savedTask.stage;

      message.success('Treinamento Agendado!');

      setSortedAppointments((prevAppointments) => [...prevAppointments, { ...dataToSave }]);

      setQuoteList((prevQuoteList) =>
        (prevQuoteList ?? []).map((quote) => {
          if (quote.id === dataToSave.dealId) {
            const updatedTasks = (quote.tasks ?? []).map((task) => {
              if (task.id === dataToSave.id) {
                return {
                  ...task,
                  ...dataToSave,
                  startDateFormatted: moment(startDate).format('DD/MM/YYYY'),
                };
              }
              return task;
            });
            return { ...quote, tasks: updatedTasks };
          }
          return quote;
        })
      );

      await TaskCommentFunctions.addTaskCommentActivities(dataToSave, oldTaskData, 'Scheduling');
      await TaskCommentFunctions.addTaskCommentHistory(dataToSave, oldTaskData, 'Scheduling');

      // Envia Notificação ao CT
      await ScheduleUtils.sendPushNotification(
        dataToSave,
        'TaskReceived',
        'CT',
        dataToSave.trainingCenterId
      );

      // Atualiza Overview e Resumo
      updateOverviewAndResume();

      if (taskRescheduling) {
        setTimeout(() => {
          setTaskRescheduling(null);
        }, 100);
      }

      setLoadingSchedule(false);
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao reservar o treinamento!');
      setLoadingSchedule(false);
    }
  };

  const schedulingUpdateType = async (e, oldTaskData, startDate) => {
    try {
      const dataToSave = { ...e };
      const scheduleData = JSON.parse(localStorage.getItem('conecta__scheduleData'));

      if (dataToSave.acceptTerm2 && dataToSave.acceptTerm2 !== '') {
        dataToSave.stage = stages.find(({ id }) => id === 12); // 12 = Estágio "Reservado"
      } else {
        dataToSave.stage = stages.find(({ id }) => id === 10); // 10 = Estágio "Pré-Reservado"
      }

      dataToSave.trainingCenter = trainingCenter?.commercialName ?? scheduleData.trainingCenter;
      dataToSave.trainingCenterId = trainingCenter?.id ?? scheduleData.trainingCenterId;

      setLoadingSchedule(true);

      const { data: savedTask } = await api.put(
        '/Task/UpdateTaskScheduling?btnAction=Agendar',
        dataToSave
      );

      dataToSave.stage = savedTask.stage;

      message.success('Treinamento Atualizado!');

      setSortedAppointments((prevAppointments) =>
        prevAppointments.map((appointment) =>
          appointment?.id === dataToSave.id ? { ...appointment, ...dataToSave } : appointment
        )
      );

      setQuoteList((prevQuoteList) =>
        (prevQuoteList ?? []).map((quote) => {
          if (quote.id === dataToSave.dealId) {
            const updatedTasks = (quote.tasks ?? []).map((task) => {
              if (task.id === dataToSave.id) {
                return {
                  ...task,
                  ...dataToSave,
                  startDateFormatted: moment(startDate).format('DD/MM/YYYY'),
                };
              }
              return task;
            });
            return { ...quote, tasks: updatedTasks };
          }
          return quote;
        })
      );

      await TaskCommentFunctions.addTaskCommentActivities(dataToSave, oldTaskData, 'Scheduling');
      await TaskCommentFunctions.addTaskCommentHistory(dataToSave, oldTaskData, 'Scheduling');

      // Envia Notificação ao CT
      await ScheduleUtils.sendPushNotification(
        dataToSave,
        'TaskReceived',
        'CT',
        dataToSave.trainingCenterId
      );

      // Atualiza Overview e Resumo
      updateOverviewAndResume();

      setLoadingSchedule(false);
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao atualizar o treinamento!');
      setLoadingSchedule(false);
    }
  };

  const onAppointmentAdd = async (e) => {
    try {
      const data = e.itemData;
      const oldTaskData = JSON.parse(JSON.stringify(data)); // Deep copy da task

      // verifica se a data é retroativa
      if (new Date(data.startDate) < new Date().setHours(0, 0, 0, 0)) {
        e.cancel = true;
        notifyRetroactiveDay();
        return;
      }

      // Realiza algumas validações e formatações
      const shouldCancel = SchedulingFunctions.formatAppointmmentInfo(
        data,
        ctResources,
        taskAcceptanceDeadline,
        ctResourcesSlots,
        trainingsOptions
      );
      if (shouldCancel) {
        return;
      }

      // Retorna os treinamentos que já estão nos slots
      const foundAppointments = appointments.filter(
        ({ startDate, endDate, resourceId }) =>
          ((new Date(data.startDate) >= new Date(startDate) &&
            new Date(data.startDate) <= new Date(endDate)) ||
            (new Date(data.endDate) >= new Date(startDate) &&
              new Date(data.endDate) <= new Date(endDate))) &&
          data.resourceId === resourceId
      );

      SchedulingFunctions.addSlotClassId(data, foundAppointments);

      const studentsScheduled = usedCapacity + data.qtyStudentsPerClass;
      const exceedsCapacity = studentsScheduled > trainingCenter.maxCapacityPerDay;

      // Excede Capacidade de Alunos por dia
      if (exceedsCapacity) {
        e.cancel = true;
        notifyExceededCapacity(studentsScheduled, trainingCenter.maxCapacityPerDay);
        return;
      }

      // Regras de Slot ocupado
      if (foundAppointments?.length > 0) {
        const [firstAppointment] = foundAppointments;
        const blockReason = SchedulingFunctions.evaluateOccupiedSlotShare(data, firstAppointment);
        if (blockReason) {
          e.cancel = true;
          message.warning(blockReason);
          return;
        }
      }

      // Data desabilitada
      const startDate = new Date(data.startDate);
      if (
        !ScheduleUtils.isValidAppointmentDate(startDate, trainingCenter?.workDays) ||
        ScheduleUtils.isBlockedDay(startDate, blockedDates)
      ) {
        e.cancel = true;
        notifyDisabledDate();
        return;
      }

      Modal.confirm({
        title: 'Deseja realmente reservar essa data?',
        content: <ModalConfirmBody itemData={data} />,
        okText: 'Não',
        cancelText: 'Sim',
        centered: true,
        style: { alignItems: 'center' },
        icon: null,
        cancelButtonProps: {
          type: 'primary',
          style: {
            backgroundColor: '#5cb85c',
            borderColor: 'transparent',
            color: '#fff',
            width: '40%',
          },
        },
        okButtonProps: {
          type: 'default',
          style: {
            width: '40%',
          },
        },
        onCancel: () => {
          data.startHour = form.getFieldValue('startHour');
          data.dateScheduling = moment().format('YYYY-MM-DDTHH:mm:ss');

          schedulingType(data, oldTaskData, startDate);

          form.setFieldsValue([]);
        },
        keyboard: false,
      });
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao reservar o treinamento!');
    }
  };

  const onAppointmentUpdating = async (e) => {
    try {
      const oldData = e.oldData ?? {};
      const newData = e.newData ?? {};
      const data = { ...oldData, ...newData };
      const oldTaskData = JSON.parse(JSON.stringify(oldData)); // Deep copy da task anterior

      // evita update "vazio"
      const hasChanges =
        Object.keys(newData).length > 0 &&
        (newData.startDate !== undefined ||
          newData.endDate !== undefined ||
          newData.resourceId !== undefined ||
          newData.slotId !== undefined ||
          newData.sharedTraining !== undefined ||
          newData.acceptSharedTraining !== undefined);
      if (!hasChanges) return;

      // verifica se a data é retroativa
      if (new Date(data.startDate) < new Date().setHours(0, 0, 0, 0)) {
        e.cancel = true;
        notifyRetroactiveDay();
        return;
      }

      // Realiza algumas validações e formatações
      const shouldCancel = SchedulingFunctions.formatAppointmmentInfo(
        data,
        ctResources,
        taskAcceptanceDeadline,
        ctResourcesSlots,
        trainingsOptions
      );
      if (shouldCancel) {
        e.cancel = true;
        return;
      }

      // Retorna os treinamentos que já estão nos slots (desconsidera o próprio card)
      const foundAppointments = appointments
        .filter((appt) => appt?.id !== data.id)
        .filter(
          ({ startDate, endDate, resourceId }) =>
            ((new Date(data.startDate) >= new Date(startDate) &&
              new Date(data.startDate) <= new Date(endDate)) ||
              (new Date(data.endDate) >= new Date(startDate) &&
                new Date(data.endDate) <= new Date(endDate))) &&
            data.resourceId === resourceId
        );

      SchedulingFunctions.addSlotClassId(data, foundAppointments);

      const oldQty = oldData?.qtyStudentsPerClass ?? 0;
      const newQty = data?.qtyStudentsPerClass ?? 0;
      const studentsScheduled = usedCapacity - oldQty + newQty;
      const exceedsCapacity = studentsScheduled > trainingCenter.maxCapacityPerDay;

      // Excede Capacidade de Alunos por dia
      if (exceedsCapacity) {
        e.cancel = true;
        notifyExceededCapacity(studentsScheduled, trainingCenter.maxCapacityPerDay);
        return;
      }

      // Regras de Slot ocupado
      if (foundAppointments?.length > 0) {
        const [firstAppointment] = foundAppointments;
        const blockReason = SchedulingFunctions.evaluateOccupiedSlotShare(data, firstAppointment);
        if (blockReason) {
          e.cancel = true;
          message.warning(blockReason);
          return;
        }
      }

      // Data desabilitada
      const startDate = new Date(data.startDate);
      if (
        !ScheduleUtils.isValidAppointmentDate(startDate, trainingCenter?.workDays) ||
        ScheduleUtils.isBlockedDay(startDate, blockedDates)
      ) {
        e.cancel = true;
        notifyDisabledDate();
        return;
      }

      // Cancela o update padrão e persiste via API (para movimentação entre recursos funcionar)
      e.cancel = true;

      Modal.confirm({
        title: 'Deseja realmente mover esse agendamento?',
        content: <ModalConfirmBody itemData={data} />,
        okText: 'Não',
        cancelText: 'Sim',
        centered: true,
        style: { alignItems: 'center' },
        icon: null,
        cancelButtonProps: {
          type: 'primary',
          style: {
            backgroundColor: '#5cb85c',
            borderColor: 'transparent',
            color: '#fff',
            width: '40%',
          },
        },
        okButtonProps: {
          type: 'default',
          style: {
            width: '40%',
          },
        },
        onCancel: () => {
          data.startHour = form.getFieldValue('startHour');
          data.dateScheduling = moment().format('YYYY-MM-DDTHH:mm:ss');

          schedulingUpdateType(data, oldTaskData, startDate);

          form.setFieldsValue([]);
        },
        keyboard: false,
      });
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao mover o treinamento!');
      e.cancel = true;
    }
  };

  const onAppointmentDblClick = (e) => {
    e.cancel = true;

    const appointmentId = ScheduleUtils.readClickedAppointmentId(e);
    if (appointmentId == null) {
      return;
    }

    setCurrentTaskId(appointmentId);
    setIsTaskDrawerVisible(true);
  };

  const onAppointmentDeleting = async (e) => {
    e.cancel = true;
    const data = JSON.parse(JSON.stringify(e.appointmentData)); // Deep Copy da task

    // 5 = Concluido
    if (data.stage.id === 5) {
      notifyDisableDelete();
      return;
    }

    onModalOk = async (stageId) => {
      setLoadingSchedule(true);
      const newStage = stages?.find(({ id }) => id === stageId);

      await api
        .delete(`/Task?taskId=${data.id}&stageId=${stageId}`)
        .then(() => {
          message.success('Treinamento Removido!');
        })
        .catch((error) => {
          Utils.logError(error);
          message.error('Oops. Algo deu errado ao tentar remover o Treinamento!');
        });

      appointments.splice(data.index, 1); // Remove da lista
      setSortedAppointments([...appointments]);

      // Atualiza Overview e Resumo
      updateOverviewAndResume();

      const quote = quoteList?.find(({ id }) => id === data.dealId);
      const task = quote?.tasks?.find(({ id }) => id === data.id);

      if (quote && task) {
        const indexTask = quote.tasks.indexOf(task);
        const indexQuote = quoteList.indexOf(quote);

        task.stage = newStage;
        task.startDateFormatted = null;
        quote.tasks.splice(indexTask, 1, task);
        quoteList.splice(indexQuote, 1, quote);
        setQuoteList([...quoteList]);
      }
      setLoadingSchedule(false);
    };

    event = 'TaskRemoved';
    currentOpenTask = data;
    setReasonModalOpen(true);
  };

  const renderDataCell = (itemData) => (
    <DataCell
      itemData={itemData}
      workDays={trainingCenter?.workDays}
      blockedDates={blockedDates}
      ctResourcesSlots={ctResourcesSlots}
      appointments={appointments}
      showResourceCapacity
    />
  );

  const renderDateCell = (itemData) => (
    <DateCell itemData={itemData} workDays={trainingCenter?.workDays} blockedDates={blockedDates} />
  );

  const removeAppointmentByIndex = (index) => {
    appointments.splice(index, 1);
    setSortedAppointments([...appointments]);
  };

  const renderAppointmentTooltip = (itemData) => (
    <AppointmentTooltipComponent
      key={ScheduleUtils.readAppointmentTooltipKey(itemData)}
      itemData={itemData}
      reasonsOptions={reasonsOptions}
      schedulerRef={schedulerRef}
      setTaskRescheduling={setTaskRescheduling}
      removeAppointmentByIndex={removeAppointmentByIndex}
    />
  );

  const resourceCellRender = (itemData) => <ResourceCellRender itemData={itemData} />;

  const appointmentRender = (itemData) => <Appointment itemData={itemData} />;

  const onAppointmentRendered = (e) => {
    const appointmentElement =
      e.appointmentElement?.get?.(0) ?? e.appointmentElement?.[0] ?? e.appointmentElement;
    stripNativeTitleFromSchedulerAppointment(appointmentElement);
  };

  const fetchQuotes = async (dealIds) => {
    const batchSize = 30;
    const results = [];

    if (dealIds && dealIds.length > 0) {
      for (let i = 0; i < dealIds.length; i += batchSize) {
        const batch = dealIds.slice(i, i + batchSize);

        try {
          const response = await api.get(
            `/Quote?filters[0].Field=DealId&filters[0].Condition=NUMBER.IN&filters[0].Value=${batch.join(
              ','
            )}`
          );
          results.push(...response.data);
        } catch (error) {
          Utils.logError(error);
          setLoading(false);
          message.error('Oops. Algo deu errado ao buscar os Negócios!');
          throw error;
        }
      }
    }

    return results;
  };

  const fetchSlots = async () => {
    const scheduleData = JSON.parse(localStorage.getItem('conecta__scheduleData'));
    const ctId =
      scheduleData?.trainingCenterId ?? schedulingScheduleFilter?.filters?.trainingCenterId;

    const slotsToFunction = await api
      .get(
        `/Slot?filters[0].Field=TrainingCenterId&filters[0].Condition=NUMBER.EQUAL&filters[0].Value=${ctId}`
      )
      .then((res) => res.data)
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao tentar buscar os Slots!');
      });

    const mappedSlots = slotsToFunction.map((slot) => ({ key: slot.id, ...slot }));
    setSlots(mappedSlots);
    return slotsToFunction;
  };

  const callSlotGeneration = (ct, readyDate, startDate, endDate, slotsToFunction) => {
    const dateKey = moment(readyDate ?? moment(scheduleDate)).format('YYYY-MM-DD');
    let filterStartDate = moment(new Date(moment(scheduleDate)).setHours(0, 0, 0, 1)).format(
      'YYYY-MM-DDTHH:mm:ss'
    );
    let filterEndDate = null;

    if (startDate && endDate) {
      filterStartDate = moment(startDate.setHours(0, 0, 0, 1)).format('YYYY-MM-DDTHH:mm:ss');
      filterEndDate = moment(endDate.setHours(23, 59, 59, 99)).format('YYYY-MM-DDTHH:mm:ss');
    }

    // Inicio do calculo de horas de cada Slot das Pistas
    const resources = {};
    const resourcesSlots = {};
    SchedulingFunctions.calculateResourceSlots(
      resources,
      ct ?? trainingCenter,
      slotsToFunction,
      filterStartDate,
      filterEndDate
    );
    SchedulingFunctions.generateResourceSlots(resources, resourcesSlots);
    setCtResourcesSlots(resourcesSlots);
    setCtResources(resources[dateKey]);
  };

  const handleFetchTasks = async (ct, startDate, endDate) => {
    try {
      const storageDate = JSON.parse(localStorage.getItem('conecta__scheduleData'))?.date;
      const dateF = schedulingScheduleFilter?.filters?.currentDate ?? storageDate;

      let filterStartDate = null;
      let filterEndDate = null;

      if (!startDate || !endDate) {
        filterStartDate = moment(new Date(dateF).setHours(0, 0, 0, 1)).format(
          'YYYY-MM-DDTHH:mm:ss'
        );
        filterEndDate = moment(new Date(dateF).setHours(23, 59, 59, 999)).format(
          'YYYY-MM-DDTHH:mm:ss'
        );
      } else {
        filterStartDate = moment(startDate.setHours(0, 0, 0, 1)).format('YYYY-MM-DDTHH:mm:ss');
        filterEndDate = moment(endDate.setHours(23, 59, 59, 999)).format('YYYY-MM-DDTHH:mm:ss');
      }

      const searchedCenter = ct ?? trainingCenter;
      const taskFilters = {
        startDate: filterStartDate,
        endDate: filterEndDate,
        trainingCenterIds: [searchedCenter?.id],
      };

      const tasks = await fetchTasks(taskFilters);
      const agendaColumns = pickAgendaColumnsForCenter(
        searchedCenter,
        slots,
        filterStartDate,
        filterEndDate
      );
      const resolvedTasks = resolveAgendaTasksForGrid(tasks, agendaColumns);

      if (resolvedTasks.length > 0) {
        SchedulingFunctions.getOverviewData(
          resolvedTasks,
          setOverview,
          filterStartDate,
          filterEndDate
        );

        SchedulingFunctions.getResumeData(resolvedTasks, setResume, filterStartDate, filterEndDate);

        if (taskRescheduling) {
          const [tasksResc] = taskRescheduling;
          const [taskResc] = tasksResc.tasks;

          setSortedAppointments(resolvedTasks.filter((x) => x.id !== taskResc.id));
        } else {
          setSortedAppointments(resolvedTasks);
        }
      } else {
        setSortedAppointments([]);
        setOverview([]);
        setResume([]);
      }
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao buscar os treinamentos!');
    }
  };

  const fetchTrainingCenter = async () => {
    try {
      setLoading(true);
      const ctId = parseInt(
        schedulingScheduleFilter?.filters?.trainingCenterId ??
          JSON.parse(localStorage.getItem('conecta__scheduleData'))?.trainingCenterId,
        10
      );

      const response = await api
        .get(
          `/TrainingCenter?filters[0].Field=CompanyType&filters[0].Condition=EQUAL&filters[0].Value=Centro de Treinamento&filters[1].Field=Status&filters[1].Condition=EQUAL&filters[1].Value=Ativo`
        )
        .then(async (res) => res.data);

      const filteredAndSortedTrainingCenters = response
        .filter(
          (tc) =>
            tc.ctQtySlots > 0 ||
            tc.inCompanyQtySlots > 0 ||
            tc.eadQtySlots > 0 ||
            tc.serviceQtySlots > 0
        )
        .map((item) => ({ ...item, label: item.commercialName, value: item.id }))
        .sort((a, b) => b.ctQtyslots - a.ctQtyslots);

      const trainingCenter = filteredAndSortedTrainingCenters?.find(({ id }) => id === ctId);
      const slotsToFunction = await fetchSlots(trainingCenter);
      const resSchedulingScheduleFilter = await fetchSchedulingScheduleFilter();
      const scheduleData = JSON.parse(localStorage.getItem('conecta__scheduleData'));

      // Preenche os filtros
      if (resSchedulingScheduleFilter) {
        const { filters } = resSchedulingScheduleFilter;
        let ct = filteredAndSortedTrainingCenters?.find(
          ({ id }) => id === filters.trainingCenterId
        );

        if (scheduleData?.fromOverview === true) {
          const storageCtId = parseInt(scheduleData.trainingCenterId, 10);
          ct = filteredAndSortedTrainingCenters?.find(({ id }) => id === storageCtId);
          resSchedulingScheduleFilter.filters.trainingCenterId = storageCtId;

          resSchedulingScheduleFilter.filters.currentDate = moment(
            new Date(scheduleData.date)
          ).format('YYYY-MM-DD');
          scheduleDate = moment(new Date(scheduleData.date)).format('YYYY-MM-DD');
        } else {
          scheduleDate = resSchedulingScheduleFilter?.filters?.currentDate;
        }

        setTrainingCenter(ct);
        setSchedulingScheduleFilter(resSchedulingScheduleFilter);
      } else {
        setTrainingCenter(trainingCenter);
      }

      callSlotGeneration(trainingCenter, null, null, null, slotsToFunction);
      setTrainingCenterOptions(filteredAndSortedTrainingCenters);

      if (
        scheduleData?.fromOverview === true ||
        !resSchedulingScheduleFilter?.filters?.currentDate
      ) {
        localStorage.setItem(
          'conecta__scheduleData',
          JSON.stringify({ ...scheduleData, fromOverview: false })
        );

        await handleFetchTasks(trainingCenter);
      } else {
        const filterDate = moment(resSchedulingScheduleFilter?.filters?.currentDate, 'YYYY-MM-DD')
          .utc()
          .toDate();
        await handleFetchTasks(trainingCenter, filterDate, filterDate);
      }

      setLoading(false);
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao buscas os dados do CT!');
    } finally {
      setLoading(false);
    }
  };

  const fetchInstructors = async () => {
    try {
      const ctId =
        schedulingScheduleFilter?.filters?.trainingCenterId ??
        JSON.parse(localStorage.getItem('conecta__scheduleData'))?.trainingCenterId;

      const filter = `/Instructor?filters[0].Field=CompanyType&filters[0].Condition=EQUAL&filters[0].Value=Instrutor&filters[1].Value=${ctId}&filters[1].Condition=NUMBER.ARRAY_CONTAIN&filters[1].Field=WorkTrainingCenters&filters[2].Field=Status&filters[2].Condition=DIFFERENT&filters[2].Value=Inativo`;
      const companyInstructors = await api.get(filter).then((res) => res.data);

      const chunkSize = 30;
      let instructors = [];

      for (let i = 0; i < companyInstructors?.length; i += chunkSize) {
        const chunkInstructors = companyInstructors?.slice(i, i + chunkSize);
        const instructorIds = chunkInstructors.map(({ id }) => id).toString();
        const userFilter = `/User?filters[0].Field=Company.Id&filters[0].Condition=NUMBER.IN&filters[0].Value=${instructorIds}&filters[1].Field=Status&filters[1].Condition=DIFFERENT&filters[1].Value=Inativo`;

        const chunkInstructorOptions = await api.get(userFilter).then((res) => res.data);
        const mappedInstructors = chunkInstructorOptions.map((item) => {
          const instructorData = companyInstructors.find(({ id }) => id === item.company.id);

          return { ...instructorData, ...item };
        });
        instructors = [...instructors, ...mappedInstructors];
      }

      setInstructorOptions(instructors);
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao buscar os Instrutores!');
    }
  };

  const fetchDrivers = async () => {
    try {
      const filter = `/Driver?filters[0].Field=CompanyType&filters[0].Condition=EQUAL&filters[0].Value=Motorista`;
      const companyDrivers = await api.get(filter).then((res) => res.data);

      const chunkSize = 30;
      let drivers = [];

      for (let i = 0; i < companyDrivers?.length; i += chunkSize) {
        const chunkDrivers = companyDrivers?.slice(i, i + chunkSize);
        const driverIds = chunkDrivers.map(({ id }) => id).toString();
        const userFilter = `/User?filters[0].Field=Company.Id&filters[0].Condition=NUMBER.IN&filters[0].Value=${driverIds}`;

        const chunkDriverOptions = await api.get(userFilter).then((res) => res.data);

        // Mapeamento dos motoristas para garantir campos obrigatórios
        const mappedDrivers = chunkDriverOptions.map((driver) => ({
          ...driver,
          userId: driver.id,
          userName: driver.name,
        }));

        drivers = [...drivers, ...mappedDrivers];
      }

      setDriverOptions(drivers);
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao buscar os Motoristas!');
    }
  };

  const fetchTransportCompanies = async () => {
    try {
      const response = await api.get(
        '/Transport?filters[0].Field=CompanyType&filters[0].Condition=IN&filters[0].Value=Transporte&filters[1].Field=Status&filters[1].Condition=DIFFERENT&filters[1].Value=Inativo'
      );

      const responseMapped = response.data.map((tc) => ({
        ...tc,
        value: tc.id,
        label: tc.commercialName || tc.name,
      }));
      setTransportOptions(responseMapped);
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao tentar buscar as Empresas de Transporte!');
    }
  };

  const fetchInvoiceIssuers = async () => {
    try {
      const response = await api.get(
        '/InvoiceIssuer?filters[0].Field=Status&filters[0].Condition=DIFFERENT&filters[0].Value=Inativo'
      );

      const responseMapped = response.data.map((invoiceIssuer) => ({
        ...invoiceIssuer,
        value: invoiceIssuer.id,
        label: `${invoiceIssuer.name} - ${invoiceIssuer.cnpj}`,
      }));
      setInvoiceIssuersOptions(responseMapped);
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao tentar buscar as Emissores de Nota Fiscal!');
    }
  };

  const fetchVehicles = () =>
    api
      .get(
        '/Vehicle?filters[0].Field=Status&filters[0].Condition=DIFFERENT&filters[0].Value=Inativo'
      )
      .then((res) => {
        const mappedOptions = res.data.map((item) => ({
          ...item,
          value: item.id,
          label: `${item.licensePlate} - ${item.type.name} (${item.capacity} lugares)`,
        }));

        setVehicleOptions(mappedOptions);
      })
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar Veículos!');
      });

  const fetchTrainings = () =>
    api
      .get('/Trainings')
      .then((res) => setTrainingsOptions(res.data))
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os Grupos de Treinamento!');
      });

  const fetchBlockedDays = () => {
    const ctId =
      schedulingScheduleFilter?.filters?.trainingCenterId ??
      JSON.parse(localStorage.getItem('conecta__scheduleData'))?.trainingCenterId;
    return api
      .get(
        `/BlockedDay?filters[0].Field=TrainingCenterId&filters[0].Condition=NUMBER.EQUAL&filters[0].Value=${ctId}`
      )
      .then((res) => setBlockedDates(res.data))
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os Dias Bloqueados do CT!');
      });
  };

  const fetchInstructorsBlockedDays = () =>
    api
      .get(
        `/BlockedDay?filters[0].Field=InstructorId&filters[0].Condition=ISNOTNULL&filters[0].Value=null`
      )
      .then((res) => setInstructorsBlockedDates(res.data))
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os Dias Bloqueados dos Instrutores!');
      });

  const fetchStages = () =>
    api
      .get(`/Stage`)
      .then((res) => setStages(res.data))
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os estágios!');
      });

  const fetchReasons = async () => {
    const reasons = await api
      .get(
        `/DenyTaskReason?filters[0].Field=Type&filters[0].Condition=IN&filters[0].Value=Scheduling,Logistics,NoBilling&filters[1].Field=Status&filters[1].Condition=DIFFERENT&filters[1].Value=Inativo`
      )
      .then((res) => res.data)
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os motivos de descarte!');
      });

    setReasonsOptions(
      reasons?.map(({ id, name, type }) => ({
        label: name,
        value: id,
        type,
      }))
    );

    setReasonNoBillingOptions(
      reasons
        ?.filter(({ type }) => type === 'NoBilling')
        .map((item) => ({
          ...item,
          label: item.name,
          value: item.id,
          type: item.type,
        }))
    );
  };

  const fetchSettings = () =>
    api
      .get(`/Settings?id=1`)
      .then(async (res) => {
        const decryptedResponse = Utils.decryptSettings(res.data);

        taskAcceptanceDeadline = decryptedResponse.taskAcceptanceDeadline;
        SchedulingFunctions.fetchBitrixProducts(
          decryptedResponse?.bitrixWebhookUrl,
          setBitrixProducts
        );
        UserFunctions.fetchBitrixUsers(decryptedResponse?.bitrixWebhookUrl, setBitrixUsers);
        setCertificateModelOptions(decryptedResponse.certificateModelList ?? []);
        setSettings(decryptedResponse);
      })
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar as configurações!');
      });

  const fetchOpenTraining = async () => {
    if (urlParams?.action === 'OpenTraining') {
      const tasks = await api
        .get(
          `/Task?filters[0].Field=Id&filters[0].Condition=NUMBER.EQUAL&filters[0].Value=${parseInt(
            urlParams.taskId,
            10
          )}`
        )
        .then((res) => res.data);

      if (tasks?.length > 0) {
        const [task] = tasks;
        const [quote] = await fetchQuotes([task.dealId]);

        const taskMapped = { ...quote, ...task };
        setOpenTraining(taskMapped);
      }
    }
  };

  const fetchData = async () => {
    try {
      const [product] = await Promise.all([fetchProduct()]);

      setProductOptions(product);
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao tentar buscar as opções de filtro!');
    }
  };

  const onContentReady = async (e) => {
    const { component } = e;
    const date = moment(component.option('currentDate')).format('YYYY-MM-DD');

    const currentDateChanged = date !== scheduleDate;
    scheduleDate = date;

    const toolbar = [
      {
        location: 'before',
        defaultElement: 'dateNavigator',
      },
      {
        location: 'center',
        template: `<h2 class="schedule-title">${trainingCenter?.commercialName ?? ''}</h2>`,
      },
    ];

    if (firstOpen === true && urlParams?.action === 'OpenNewSlots') {
      newSlotPopupRef.current.instance.show();
    }

    const scheduledStudents = component._filteredItems
      ?.filter(({ resource }) => resource === 'CT')
      ?.map(({ qtyStudentsPerClass }) => qtyStudentsPerClass)
      .reduce((startVal, nextVal) => startVal + nextVal, 0);
    setUsedCapacity(scheduledStudents);

    if (currentDateChanged) {
      callSlotGeneration(
        trainingCenter,
        date,
        component.getStartViewDate(),
        component.getEndViewDate(),
        slots
      );

      if (!firstOpen) {
        setLoadingSchedule(true);
        await handleFetchTasks(
          trainingCenter,
          component.getStartViewDate(),
          component.getEndViewDate()
        );
        setLoadingSchedule(false);

        if (quoteListRef?.current) {
          quoteListRef.current.handleFilterSave();
        }
      }

      component.option('toolbar', toolbar);
    }

    if (firstOpen && bitrixUsers.length > 0) {
      firstOpen = false;
      component.option('toolbar', toolbar);
    }

    if (urlParams?.action === 'OpenTraining') {
      component.showAppointmentPopup(openTraining);
    }

    if (currentCTName !== trainingCenter?.name) {
      currentCTName = trainingCenter?.name;
      component.option('toolbar', toolbar);
    }
  };

  const exitReschedulingMode = () => {
    const [firstTask] = taskRescheduling[0].tasks;

    appointments.push(firstTask);
    setSortedAppointments([...appointments]);

    // Pequeno delay para garantir que a virtualização atualize corretamente
    setTimeout(() => {
      setTaskRescheduling(null);
    }, 100);
  };

  useEffect(() => {
    if (urlParams?.action === 'OpenTraining') {
      schedulerRef?.current?.instance?.showAppointmentPopup(openTraining);
    }
  }, [schedulerRef]);

  useLayoutEffect(() => {
    if (urlParams?.action === 'OpenNewSlots') {
      const scheduleStorageData = {
        trainingCenterId: urlParams.ctId,
        trainingCenter: urlParams.ctName,
        date: new Date(),
        viewType: 'day',
        maxCapacityPerDay: urlParams.ctMaxCapacity,
      };

      localStorage.setItem('conecta__scheduleData', JSON.stringify(scheduleStorageData));
    }

    setScheduleParams(JSON.parse(localStorage.getItem('conecta__scheduleData')));

    const permissions = {};
    const userRole = JSON.parse(localStorage.getItem('conecta__permissions'));
    const userRoleId = parseInt(userRole?.id ?? 0, 10);

    userRole?.resources.forEach(({ name, fields }) => {
      if (name === 'ScheduleScheduling') {
        fields.forEach(({ name, access, isRequired, isADM }) => {
          permissions[name] = { access, isRequired, isADM };
        });
      }
    });

    setRoleId(userRoleId);
    setFieldsPermissions(permissions);
    const portalResource = readPortalResource('ScheduleScheduling');
    setAgendaResourceId(portalResource.resourceId);
    setAgendaResourceName(portalResource.resourceName);
    loadAgendaFieldLayout(portalResource.resourceId).then(setFieldLayout);
    fetchSettings();
    fetchTrainingCenter();
    fetchBlockedDays();
    fetchInstructorsBlockedDays();
  }, []);

  useEffect(() => {
    fetchData();
    fetchInstructors();
    fetchDrivers();
    fetchTransportCompanies();
    fetchInvoiceIssuers();
    fetchVehicles();
    fetchTrainings();
    fetchStages();
    fetchReasons();
    fetchOpenTraining();
  }, []);

  // Reseta o carregamento da tela quando o usuário sai da tela
  useEffect(
    () => () => {
      firstOpen = true;
      scheduleDate = moment(new Date()).format('YYYY-MM-DD');
    },
    [location]
  );

  if (loading || !ctResources || !ctResourcesSlots) {
    return (
      <Row gutter={[24]}>
        <Col
          span={24}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '72vh',
          }}
        >
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 56,
                  textAlign: 'center',
                }}
                spin
              />
            }
          />
        </Col>
      </Row>
    );
  }

  if (!loading && ctResources && ctResourcesSlots) {
    return (
      <>
        {isLogistic && stages && trainingsOptions && trainingCenter && (
          <Row gutter={[12]}>
            <Col span={24}>
              <QuoteList
                ref={quoteListRef}
                isLoading={loadingSchedule}
                isLogistic={isLogistic}
                stages={stages}
                trainings={trainingsOptions}
                schedulerRef={schedulerRef}
                dealId={dealId}
                bitrixUsers={bitrixUsers}
                quoteList={quoteList}
                setQuoteList={setQuoteList}
                trainingCenterOptions={trainingCenterOptions}
                fetchInstructors={fetchInstructors}
                fetchSlots={fetchSlots}
                callSlotGeneration={callSlotGeneration}
                handleFetchTasks={handleFetchTasks}
                trainingCenter={trainingCenter}
                setTrainingCenter={setTrainingCenter}
                taskRescheduling={taskRescheduling}
                exitReschedulingMode={exitReschedulingMode}
                onAppointmentDblClick={onAppointmentDblClick}
                setIsTaskReadOnly={setIsTaskReadOnly}
                schedulingScheduleFilter={schedulingScheduleFilter}
                setSchedulingScheduleFilter={setSchedulingScheduleFilter}
                fieldsPermissions={fieldsPermissions}
                getCurrentDate={getCurrentDate}
                instructorBookingPopupRef={instructorBookingPopupRef}
                resumePopupRef={resumePopupRef}
                overviewPopupRef={overviewPopupRef}
                newSlotPopupRef={newSlotPopupRef}
              />
            </Col>
          </Row>
        )}

        <Row gutter={[12]}>
          {!isLogistic && (
            <Col span={5}>
              {stages && trainingsOptions && trainingCenter && (
                <QuoteList
                  ref={quoteListRef}
                  isLoading={loadingSchedule}
                  isLogistic={isLogistic}
                  stages={stages}
                  trainings={trainingsOptions}
                  schedulerRef={schedulerRef}
                  dealId={dealId}
                  bitrixUsers={bitrixUsers}
                  quoteList={quoteList}
                  setQuoteList={setQuoteList}
                  trainingCenterOptions={trainingCenterOptions}
                  fetchInstructors={fetchInstructors}
                  fetchSlots={fetchSlots}
                  callSlotGeneration={callSlotGeneration}
                  handleFetchTasks={handleFetchTasks}
                  trainingCenter={trainingCenter}
                  setTrainingCenter={setTrainingCenter}
                  taskRescheduling={taskRescheduling}
                  exitReschedulingMode={exitReschedulingMode}
                  onAppointmentDblClick={onAppointmentDblClick}
                  setIsTaskReadOnly={setIsTaskReadOnly}
                  schedulingScheduleFilter={schedulingScheduleFilter}
                  setSchedulingScheduleFilter={setSchedulingScheduleFilter}
                  fieldsPermissions={fieldsPermissions}
                  getCurrentDate={getCurrentDate}
                  instructorBookingPopupRef={instructorBookingPopupRef}
                  resumePopupRef={resumePopupRef}
                  overviewPopupRef={overviewPopupRef}
                  newSlotPopupRef={newSlotPopupRef}
                />
              )}
            </Col>
          )}

          {scheduleParams && (
            <Col span={isLogistic ? 24 : 19}>
              <NewSlotPopup
                newSlotPopupRef={newSlotPopupRef}
                slots={slots}
                setSlots={setSlots}
                getCurrentDate={getCurrentDate}
                trainingCenter={trainingCenter}
                bitrixProducts={bitrixProducts}
                callSlotGeneration={callSlotGeneration}
              />

              <OverviewPopup
                overviewPopupRef={overviewPopupRef}
                overviewList={overview}
                totalStudents={trainingCenter?.maxCapacityPerDay}
                getCurrentDate={getCurrentDate}
              />

              <ResumePopup
                resumePopupRef={resumePopupRef}
                resumeList={resume}
                schedulerRef={schedulerRef}
                getCurrentDate={getCurrentDate}
                ctName={trainingCenter?.name}
              />

              <InstructorBookingPopup
                instructorBookingPopupRef={instructorBookingPopupRef}
                getCurrentDate={getCurrentDate}
                instructors={instructorOptions}
                instructorsBlockedDates={instructorsBlockedDates}
              />

              <Scheduler
                ref={schedulerRef}
                disabled={loadingSchedule}
                id="scheduleScheduling"
                style={isLogistic ? null : { marginTop: 70 }}
                views={views}
                groups={groups}
                groupByDate
                dataSource={appointments}
                defaultCurrentView="Dia"
                defaultCurrentDate={schedulerDefaultDate ?? new Date(scheduleParams.date)}
                startDayHour={8}
                endDayHour={18}
                showAllDayPanel={false}
                firstDayOfWeek={1}
                maxAppointmentsPerCell={1}
                dataCellRender={renderDataCell}
                dateCellRender={renderDateCell}
                resourceCellRender={resourceCellRender}
                onAppointmentDblClick={onAppointmentDblClick}
                onAppointmentFormOpening={onAppointmentDblClick}
                onAppointmentDeleting={onAppointmentDeleting}
                appointmentComponent={appointmentRender}
                onAppointmentRendered={onAppointmentRendered}
                appointmentTooltipRender={renderAppointmentTooltip}
                appointmentTooltipKeyFn={ScheduleUtils.readAppointmentTooltipKey}
                onAppointmentUpdating={onAppointmentUpdating}
                onContentReady={onContentReady}
                crossScrollingEnabled
                showCurrentTimeIndicator={false}
                editing={{
                  allowResizing: false,
                }}
                onCellClick={(e) => {
                  e.cancel = true;
                }}
              >
                <AppointmentDragging
                  group={draggingGroupName}
                  onAdd={onAppointmentAdd}
                  onDragStart={(e) => {
                    if (!(fieldsPermissions?.CanMoveScheduledCards.access > 0)) {
                      e.cancel = true;
                    }
                  }}
                />

                <Resource
                  fieldExpr="resourceId"
                  allowMultiple={false}
                  dataSource={ctResources}
                  label="Recurso"
                />
              </Scheduler>

              {isReasonModalOpen && (
                <ReasonModal
                  setModalOpen={setReasonModalOpen}
                  reasonsOptions={reasonsOptions}
                  currentOpenTask={currentOpenTask}
                  event={event}
                  eventSource="Scheduling"
                  onOk={onModalOk}
                />
              )}

              {isTaskDrawerVisible && (
                <TaskDrawer
                  taskId={currentTaskId}
                  fieldsPermissions={fieldsPermissions}
                  stages={stages}
                  instructorOptions={instructorOptions}
                  trainingsOptions={trainingsOptions}
                  ctResources={ctResources}
                  transportOptions={transportOptions}
                  reasonNoBillingOptions={reasonNoBillingOptions}
                  invoiceIssuersOptions={invoiceIssuersOptions}
                  vehicleOptions={vehicleOptions}
                  driverOptions={driverOptions}
                  productOptions={productOptions}
                  certificateModelOptions={certificateModelOptions}
                  setIsTaskDrawerVisible={setIsTaskDrawerVisible}
                  taskAcceptanceDeadline={taskAcceptanceDeadline}
                  ctResourcesSlots={ctResourcesSlots}
                  setAppointments={setSortedAppointments}
                  setQuoteList={setQuoteList}
                  appointments={appointments}
                  quoteList={quoteList}
                  isTaskReadOnly={isTaskReadOnly}
                  setIsTaskReadOnly={setIsTaskReadOnly}
                  isLogistic={isLogistic}
                  settings={settings}
                  resourceId={agendaResourceId}
                  resourceName={agendaResourceName}
                  fieldLayout={fieldLayout}
                  roleId={roleId}
                />
              )}
            </Col>
          )}
        </Row>
      </>
    );
  }
}

const ScheduleScheduling = memo(ScheduleSchedulingComponent);
export default ScheduleScheduling;
